import React, { FC, useState } from "react";
import { Button } from "@chakra-ui/button";
import { Input, InputRightElement, InputGroup } from "@chakra-ui/input";
import Heading from "components/UIComponents/Typography/Heading";
import { FaTimes } from "react-icons/fa";
import { useIntl } from "react-intl";
import { useMobileContext } from "context/MobileContext";
import "./CheckersInputBlock.css";
import { Box, Divider, Tooltip } from "@chakra-ui/react";

interface CheckerInputBlockProps {
  heading: string;
  placeholder: string;
  buttonText: string;
  isInputEmpty: boolean;
  onClick: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setIPAddress: (value: string) => void;
  ipAddress: string;
}

const CheckersInputBlock: FC<CheckerInputBlockProps> = ({
  heading,
  placeholder,
  buttonText,
  isInputEmpty,
  onClick,
  onChange,
  setIPAddress,
  ipAddress,
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onClick();
    }
  };

  const intl = useIntl();
  const { isMobile } = useMobileContext();

  const resetValue = () => {
    setIPAddress("");
  };

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setTimeout(() => {
      setIsInputFocused(false);
    }, 500);
  };

  return (
    <section className="checkers-input-block">
      <div className="ckecker-input-block-content">
        <Heading>{heading}</Heading>
        <InputGroup size="lg" w={!isMobile ? "80%" : "100%"} mx="auto">
          <Input
            className="checker-input-block-input"
            type="text"
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            value={ipAddress}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />
          <InputRightElement width="auto" mr={4}>
            {!isInputEmpty && isInputFocused && (
              <>
                <Box
                  width="auto"
                  mr="20px"
                  onClick={resetValue}
                  cursor="pointer"
                >
                  <FaTimes />
                  {!isMobile && (
                    <Divider
                      orientation="vertical"
                      width="2px"
                      height="80%"
                      ml={4}
                    />
                  )}
                </Box>
              </>
            )}
            <Tooltip
              label={`${isInputEmpty ? "Enter IP address to check" : ""}`}
            >
              <Button
                h="2rem"
                size="lg"
                p={4}
                colorScheme="blue"
                onClick={onClick}
                isDisabled={isInputEmpty}
              >
                {`${intl.formatMessage({ id: "CheckText" })} ${buttonText}`}
              </Button>
            </Tooltip>
          </InputRightElement>
        </InputGroup>
      </div>
    </section>
  );
};

export default CheckersInputBlock;
